/*****components***/
import React, { Component } from "react";
import {
  Table as AntTable,
  Tabs,
  Tag,
  Drawer,
  Checkbox,
  Select,
  DatePicker,
  Input,
  Button,
  Empty,
  Tooltip,
} from "antd";
import moment from "moment";
import { ExcelJS, addSummarySheet, addDataSheet, downloadWorkbook } from "./excelExportUtils";
import { API_CONFIG } from "../../Config/config-env.js";
import axios from "axios";

/*custom components*/
import PageLoading from "../../Components/PageLoading/index.js";

/*functions*/
import { applyExternalDarkMode, searchHandler, findObjName, callexternalApi, find } from "../../Config/functions.js";

const { TabPane } = Tabs;
const { Option } = Select;

// El selector de fecha conserva la hora de carga de la pagina al elegir un dia. Se toma
// siempre el dia completo en hora Bolivia (UTC-4): 00:00:00 -> 04:00Z y 23:59:59 ->
// 03:59:59Z del dia siguiente (el backend convierte a fecha La Paz).
const BOLIVIA_OFFSET_H = 4;
const boliviaDayStart = (d) => {
  const x = new Date(d);
  return new Date(Date.UTC(x.getFullYear(), x.getMonth(), x.getDate(), BOLIVIA_OFFSET_H, 0, 0, 0));
};
const boliviaDayEnd = (d) => {
  const x = new Date(d);
  return new Date(Date.UTC(x.getFullYear(), x.getMonth(), x.getDate() + 1, BOLIVIA_OFFSET_H - 1, 59, 59, 999));
};

var f = new Date();
var fromDate = new Date();
fromDate.setDate(f.getDate() - 30);

var mes = f.getUTCMonth() + 1 < 10 ? "0" + (f.getUTCMonth() + 1) : f.getUTCMonth() + 1;
var dia = f.getUTCDate() < 10 ? "0" + f.getUTCDate() : f.getUTCDate();
var date_label = f.getUTCFullYear() + "." + mes + "." + dia;

const expandComboSkuRows = (row) => {
  if (typeof row.SKU !== "string" || row.SKU.indexOf(",") < 0) return [row];
  const skus = row.SKU.split(",").map((sku) => sku.trim()).filter((sku) => sku !== "");
  if (skus.length <= 1) return [row];
  return skus.map((sku) => ({ ...row, SKU: sku }));
};

const formatMoney = (value) =>
  Number(value || 0).toLocaleString("es-BO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const STATUS_COLORS = [
  { match: /cancelado/i, color: "red" },
  { match: /finalizado|entregado/i, color: "green" },
  { match: /pendiente de pago|pendiente pago/i, color: "volcano" },
  { match: /pendiente/i, color: "gold" },
  { match: /procesando traspaso|espera de traspaso|recepcionando/i, color: "orange" },
  { match: /picking/i, color: "orange" },
  { match: /procesando/i, color: "blue" },
  { match: /preparando/i, color: "geekblue" },
  { match: /listo para/i, color: "cyan" },
  { match: /programada/i, color: "purple" },
  { match: /espera/i, color: "orange" },
];
const statusColor = (status) => {
  const s = String(status || "");
  const found = STATUS_COLORS.find((c) => c.match.test(s));
  return found ? found.color : "default";
};

const MONEY_COLS = ["SUBTOTAL_ORDER", "SHIPPINGCOST", "DISCOUNT", "TOTAL_ORDER", "SKU_REGULAR_PRICE", "SKU_PRICE", "SKU_TOTAL"];

const PAGE_CSS = `
.xrep2 { font-size: 13px; }
.xrep2 .xrep2-header { display:flex; flex-wrap:wrap; justify-content:space-between; align-items:center; gap:12px; margin-bottom:14px; }
.xrep2 .xrep2-title h2 { margin:0; font-weight:700; letter-spacing:-0.3px; }
.xrep2 .xrep2-title small { color:#8c8c8c; }
.xrep2 .xrep2-actions { display:flex; gap:8px; align-items:center; }
.xrep2 .xrep2-panel { background:#fff; border:1px solid #ececec; border-radius:10px; padding:14px 16px; margin-bottom:14px; box-shadow:0 1px 3px rgba(15,23,42,.05); }
.xrep2 .xrep2-filters-grid { display:grid; grid-template-columns:repeat(auto-fit, minmax(170px, 1fr)); gap:10px 12px; }
.xrep2 .xrep2-field label { display:block; font-size:11px; font-weight:600; text-transform:uppercase; letter-spacing:.4px; color:#8c8c8c; margin-bottom:3px; }
.xrep2 .xrep2-filters-footer { display:flex; justify-content:space-between; align-items:center; margin-top:12px; flex-wrap:wrap; gap:8px; }
.xrep2 .xrep2-kpis { display:grid; grid-template-columns:repeat(auto-fit, minmax(170px, 1fr)); gap:12px; margin-bottom:14px; }
.xrep2 .xrep2-kpi { background:#fff; border:1px solid #ececec; border-radius:10px; padding:12px 14px; display:flex; align-items:center; gap:12px; box-shadow:0 1px 3px rgba(15,23,42,.05); }
.xrep2 .xrep2-kpi-icon { width:40px; height:40px; border-radius:10px; display:flex; align-items:center; justify-content:center; font-size:17px; color:#fff; flex-shrink:0; }
.xrep2 .xrep2-kpi-label { font-size:11px; text-transform:uppercase; letter-spacing:.4px; color:#8c8c8c; margin:0; }
.xrep2 .xrep2-kpi-value { font-size:19px; font-weight:700; margin:0; line-height:1.2; }
.xrep2 .xrep2-tables { background:#fff; border:1px solid #ececec; border-radius:10px; padding:6px 16px 16px; box-shadow:0 1px 3px rgba(15,23,42,.05); }
.xrep2 .ant-table-thead > tr > th { background:#fafafa; font-size:11px; text-transform:uppercase; letter-spacing:.3px; color:#595959; white-space:nowrap; }
.xrep2 .ant-table-tbody > tr > td { font-size:12.5px; }
.xrep2 .ant-tabs-tab { font-weight:600; }
.xrep2 .xrep2-money { text-align:right; font-variant-numeric:tabular-nums; display:block; }
.xrep2 .xrep2-orderid { font-weight:700; font-variant-numeric:tabular-nums; }
.xrep2 .xrep2-mono { font-family:SFMono-Regular,Consolas,monospace; font-size:12px; }
.xrep2 .xrep2-elapsed { color:#8c8c8c; font-size:12px; }
.xflow-external-dark .xrep2 .xrep2-panel,
.xflow-external-dark .xrep2 .xrep2-kpi,
.xflow-external-dark .xrep2 .xrep2-tables { background:#1f2430; border-color:#2c3242; }
.xflow-external-dark .xrep2 .xrep2-kpi-value { color:#e8eaf0; }
.xflow-external-dark .xrep2 .ant-table-thead > tr > th { background:#252b39; color:#aab; }
.xflow-external-dark .xrep2 .xrep2-field label { color:#8592ad; }

/* ---- Dark mode: inputs, select, datepicker (trigger) ---- */
.xflow-external-dark .xrep2 .ant-picker,
.xflow-external-dark .xrep2 .ant-select:not(.ant-select-disabled) .ant-select-selector,
.xflow-external-dark .xrep2 .ant-input,
.xflow-external-dark .xrep2 .ant-input-affix-wrapper {
  background:#0f172a; border-color:#334155; color:#f8fafc;
}
.xflow-external-dark .xrep2 .ant-picker-input > input,
.xflow-external-dark .xrep2 .ant-select-selection-item,
.xflow-external-dark .xrep2 .ant-select-selection-search-input,
.xflow-external-dark .xrep2 .ant-input {
  color:#f8fafc;
}
.xflow-external-dark .xrep2 .ant-select-selection-placeholder,
.xflow-external-dark .xrep2 .ant-picker-input > input::placeholder,
.xflow-external-dark .xrep2 .ant-input::placeholder {
  color:#64748b;
}
.xflow-external-dark .xrep2 .ant-picker-suffix,
.xflow-external-dark .xrep2 .ant-picker-clear,
.xflow-external-dark .xrep2 .ant-select-arrow,
.xflow-external-dark .xrep2 .ant-select-clear,
.xflow-external-dark .xrep2 .ant-input-clear-icon {
  color:#64748b; background:transparent;
}
.xflow-external-dark .xrep2 .ant-picker:hover,
.xflow-external-dark .xrep2 .ant-select:hover .ant-select-selector,
.xflow-external-dark .xrep2 .ant-input:hover {
  border-color:#475569;
}
.xflow-external-dark .xrep2 .ant-picker-focused,
.xflow-external-dark .xrep2 .ant-select-focused .ant-select-selector,
.xflow-external-dark .xrep2 .ant-input:focus,
.xflow-external-dark .xrep2 .ant-input-focused {
  border-color:#1890ff !important; box-shadow:0 0 0 2px rgba(24,144,255,.2) !important;
}
.xflow-external-dark .xrep2 .ant-select-multiple .ant-select-selection-item {
  background:#1e293b; border-color:#334155; color:#e2e8f0;
}
.xflow-external-dark .xrep2 .ant-select-multiple .ant-select-selection-item-remove {
  color:#94a3b8;
}

/* ---- Dark mode: buttons ---- */
.xflow-external-dark .xrep2 .ant-btn:not(.ant-btn-primary):not(.ant-btn-link) {
  background:#182235; border-color:#334155; color:#e2e8f0;
}
.xflow-external-dark .xrep2 .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):hover,
.xflow-external-dark .xrep2 .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):focus {
  background:#1e293b; border-color:#475569; color:#fff;
}
.xflow-external-dark .xrep2 .ant-btn-link { color:#60a5fa; }
.xflow-external-dark .xrep2 .ant-btn-link:hover { color:#93c5fd; }
.xflow-external-dark .xrep2 .ant-btn[disabled],
.xflow-external-dark .xrep2 .ant-btn[disabled]:hover {
  background:#141a26; border-color:#2c3242; color:#4b5568;
}

/* ---- Dark mode: tabs ---- */
.xflow-external-dark .xrep2 .ant-tabs-tab { color:#8592ad; }
.xflow-external-dark .xrep2 .ant-tabs-tab:hover { color:#e2e8f0; }
.xflow-external-dark .xrep2 .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn { color:#60a5fa; }
.xflow-external-dark .xrep2 .ant-tabs-ink-bar { background:#1890ff; }
.xflow-external-dark .xrep2 .ant-tabs-nav::before { border-color:#2c3242; }

/* ---- Dark mode: empty state ---- */
.xflow-external-dark .xrep2 .ant-empty-description { color:#8592ad; }

/* ---- Dark mode: select/datepicker popups (rendered via portal, outside .xrep2) ---- */
.xflow-external-dark .xrep2-popup.ant-select-dropdown {
  background:#182235; box-shadow:0 4px 18px rgba(0,0,0,.45);
}
.xflow-external-dark .xrep2-popup .ant-select-item {
  color:#e2e8f0;
}
.xflow-external-dark .xrep2-popup .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background:#1e293b;
}
.xflow-external-dark .xrep2-popup .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background:#0c2a3d; color:#7dd3fc;
}
.xflow-external-dark .xrep2-popup .ant-select-item-empty {
  color:#64748b;
}
.xflow-external-dark .xrep2-popup.ant-picker-dropdown .ant-picker-panel-container {
  background:#182235; box-shadow:0 4px 18px rgba(0,0,0,.45);
}
.xflow-external-dark .xrep2-popup .ant-picker-panel {
  background:#182235; border-color:#334155;
}
.xflow-external-dark .xrep2-popup .ant-picker-header {
  color:#e2e8f0; border-color:#334155;
}
.xflow-external-dark .xrep2-popup .ant-picker-header button {
  color:#94a3b8;
}
.xflow-external-dark .xrep2-popup .ant-picker-header-view button:hover {
  color:#e2e8f0;
}
.xflow-external-dark .xrep2-popup .ant-picker-content th {
  color:#94a3b8;
}
.xflow-external-dark .xrep2-popup .ant-picker-cell {
  color:#475569;
}
.xflow-external-dark .xrep2-popup .ant-picker-cell-in-view {
  color:#e2e8f0;
}
.xflow-external-dark .xrep2-popup .ant-picker-cell:hover .ant-picker-cell-inner {
  background:#1e293b;
}
.xflow-external-dark .xrep2-popup .ant-picker-cell-selected .ant-picker-cell-inner {
  background:#1890ff; color:#fff;
}
.xflow-external-dark .xrep2-popup .ant-picker-cell-today .ant-picker-cell-inner::before {
  border-color:#1890ff;
}
.xflow-external-dark .xrep2-popup .ant-picker-footer {
  border-color:#334155;
}
.xflow-external-dark .xrep2-popup .ant-picker-today-btn {
  color:#60a5fa;
}

/* ---- Dark mode: drawer (rendered via portal, outside .xrep2) ---- */
.xflow-external-dark .xrep2-drawer .ant-drawer-content,
.xflow-external-dark .xrep2-drawer .ant-drawer-header {
  background:#111827; border-color:#334155;
}
.xflow-external-dark .xrep2-drawer .ant-drawer-title,
.xflow-external-dark .xrep2-drawer .ant-drawer-close {
  color:#e2e8f0;
}
.xflow-external-dark .xrep2-drawer .ant-checkbox-wrapper {
  color:#e2e8f0;
}

/* ---- Dark mode: paginación ---- */
.xflow-external-dark .xrep2 .ant-pagination-item {
  background:#182235; border-color:#334155;
}
.xflow-external-dark .xrep2 .ant-pagination-item a {
  color:#94a3b8;
}
.xflow-external-dark .xrep2 .ant-pagination-item:hover {
  border-color:#1890ff;
}
.xflow-external-dark .xrep2 .ant-pagination-item:hover a {
  color:#1890ff;
}
.xflow-external-dark .xrep2 .ant-pagination-item-active {
  background:#0c2a3d; border-color:#1890ff;
}
.xflow-external-dark .xrep2 .ant-pagination-item-active a {
  color:#7dd3fc;
}
.xflow-external-dark .xrep2 .ant-pagination-prev .ant-pagination-item-link,
.xflow-external-dark .xrep2 .ant-pagination-next .ant-pagination-item-link {
  background:#182235; border-color:#334155; color:#94a3b8;
}
.xflow-external-dark .xrep2 .ant-pagination-prev:hover .ant-pagination-item-link,
.xflow-external-dark .xrep2 .ant-pagination-next:hover .ant-pagination-item-link {
  border-color:#1890ff; color:#1890ff;
}
.xflow-external-dark .xrep2 .ant-pagination-disabled .ant-pagination-item-link,
.xflow-external-dark .xrep2 .ant-pagination-disabled:hover .ant-pagination-item-link {
  background:#141a26; border-color:#2c3242; color:#4b5568;
}
.xflow-external-dark .xrep2 .ant-pagination-total-text,
.xflow-external-dark .xrep2 .ant-pagination-options-quick-jumper {
  color:#94a3b8;
}
.xflow-external-dark .ant-select-dropdown .ant-select-item {
  color:#e2e8f0;
}
.xflow-external-dark .ant-select-dropdown.ant-select-dropdown-placement-topLeft,
.xflow-external-dark .ant-select-dropdown.ant-select-dropdown-placement-bottomLeft {
  background:#182235; box-shadow:0 4px 18px rgba(0,0,0,.45);
}
.xflow-external-dark .ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background:#1e293b;
}
.xflow-external-dark .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background:#0c2a3d; color:#7dd3fc;
}

/* ---- Dark mode: Tag de estado ---- */
.xflow-external-dark .xrep2 .ant-tag {
  color:#e2e8f0;
}
.xflow-external-dark .xrep2 .ant-tag-default { background:#1f2937; border-color:#475569; color:#cbd5e1; }
.xflow-external-dark .xrep2 .ant-tag-blue { background:#0c2a3d; border-color:#1890ff; color:#7dd3fc; }
.xflow-external-dark .xrep2 .ant-tag-geekblue { background:#161b3d; border-color:#5470ff; color:#adc6ff; }
.xflow-external-dark .xrep2 .ant-tag-cyan { background:#083b3b; border-color:#13c2c2; color:#87e8e8; }
.xflow-external-dark .xrep2 .ant-tag-green { background:#0f2e17; border-color:#52c41a; color:#b7eb8f; }
.xflow-external-dark .xrep2 .ant-tag-gold { background:#3a2e08; border-color:#faad14; color:#ffe58f; }
.xflow-external-dark .xrep2 .ant-tag-orange { background:#3a2408; border-color:#fa8c16; color:#ffd591; }
.xflow-external-dark .xrep2 .ant-tag-volcano { background:#3a1a08; border-color:#fa541c; color:#ffbb96; }
.xflow-external-dark .xrep2 .ant-tag-red { background:#3a0d0d; border-color:#f5222d; color:#ffa39e; }
.xflow-external-dark .xrep2 .ant-tag-purple { background:#22103d; border-color:#722ed1; color:#d3adf7; }
`;

// Orden y set de columnas confirmado por negocio (documento "campos export
// orders", version final) para cada pestaña de REGALABLES — son distintos
// entre sí, por eso van en dos listas explícitas de "value" en vez de
// derivar una de la otra filtrando por nombre de campo. Los campos que no
// estan en el excel final fueron eliminados (confirmado con negocio) — ya no
// se preservan (ej. TAREA, nunca definido por negocio; SKU_PRODUCTID/NAME/COLOR).
const ORDER_TAB_ORDER = [
  "ORDERID", "DATE_ADDED", "STORENAME", "STORENAME2",
  "SUBTOTAL_ORDER", "DISCOUNT", "TOTAL_ORDER",
  "STATUSNAME", "DATE_MODIFIED",
  "HAVECOUPON", "COUPONCODE", "COUPONADMINCODE", "COUPONVALUE",
  "POSICION_RACK", "OBSERVACION", "EVENTTYPE", "EVENTNAME",
  "FIRSTNAME", "LASTNAME", "EMAIL", "PHONE",
  "SHIPPINGADDRESS", "ADDITIONALSHIPPINGINSTRUCTIONS", "ZONECODE", "SHIPPINGTYPE",
  "NIT", "RAZON_SOCIAL", "NROFACTURA", "INVOICE_STATUS", "TRX", "OPCIONCLIENTE", "NOTA_SAP",
];

const SKU_TAB_ORDER = [
  "ORDERID", "DATE_ADDED", "STORENAME", "STORENAME2",
  "SKU", "SKU_NAME", "SKU_CATEGORYNAME", "SKU_KEYVARIANT", "SKU_SIZE", "SKU_REGULAR_PRICE",
  "DISCOUNT", "SKU_PRICE", "SKU_QUANTITY", "SKU_TOTAL", "SHIPPINGCOST", "TOTAL_ORDER",
  "STATUSNAME", "DATE_MODIFIED", "EVENTNAME", "EVENTTYPE", "SHIPPING_CITY", "SHIPPINGMETHOD",
  "HAVECOUPON", "COUPONCODE", "COUPONADMINCODE", "COUPONVALUE", "NOTA_SAP",
  "NIT", "RAZON_SOCIAL", "NROFACTURA", "INVOICE_STATUS", "INVOICE_DATE", "TRX",
];

class page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      drawerFields: false,
      pageSize: 20,
      api_urlV2: "",
      date_label: date_label,
      exportOrders: [],
      exportSkus: [],
      exportOrderCols: [],
      exportSkuCols: [],
      isChecked: true,
      summary: null,
      activeTab: "orders",
      showAllFilters: false,
      filterConfig: {
        EVENTTYPEID: { label: "Tipo Evento", type: "SELECT", values: [{ text: "TODOS", value: "" }], value: "" },
        ORDERID: { label: "Nro Pedido Desde", type: "NUMBER", value: "" },
        ORDERID_TO: { label: "Nro Pedido Hasta", type: "NUMBER", value: "" },
        CUSTOMER_NAME: { label: "Nombre Cliente", type: "TEXT", value: "" },
        FROMDATE: { label: "Desde", type: "DATE", value: fromDate },
        TODATE: { label: "Hasta", type: "DATE", value: new Date() },
        CITY: { label: "Ciudad", type: "SELECT", values: [{ text: "TODAS", value: "" }], value: "" },
        STOREID: { label: "Tienda", type: "MULTIPLE", values: [{ text: "TODAS", value: "" }], value: "" },
        STATUSID: { label: "Estado", type: "MULTIPLE", values: [{ text: "TODOS", value: "" }], value: "" },
        PAYMENTTYPEID: { label: "Tipo Pago", type: "MULTIPLE", values: [{ text: "TODOS", value: "" }], value: "" },
        SHIPPINGTYPEID: { label: "Tipo Envío", type: "MULTIPLE", values: [{ text: "TODOS", value: "" }], value: "" },
        MIN_PRICE: { label: "Monto Max", type: "NUMBER", value: "0" },
        MAX_PRICE: { label: "Monto Min", type: "NUMBER", value: "999999" },
        HAVE_COUPON: {
          label: "Tiene Convenio", type: "SELECT", value: "",
          values: [{ text: "TODOS", value: "" }, { text: "SI", value: "YES" }, { text: "NO", value: "NO" }],
        },
        COUPONNAME: { label: "Nombre del Cupón", type: "SELECT", value: "", values: [{ text: "TODOS", value: "" }] },
      },
      showMore: true,
      events: [],
      tipos_evento: [],
      tableData: { columns: [], rows: [] },
      tableData2: { columns: [], rows: [] },
      // Lista canónica de campos disponibles (fuente del drawer de
      // habilitar/deshabilitar columnas). El orden real de cada pestaña se
      // arma desde ORDER_TAB_ORDER / SKU_TAB_ORDER (arriba del archivo);
      // acá solo se busca `enabled`/`width` por `value`.
      // FIRSTNAME/LASTNAME/EMAIL/PHONE vienen de o.nombre/o.apellido_paterno/
      // o.email/o.telefono en la orden — es decir, de quien REALIZÓ LA COMPRA,
      // no del organizador del evento (ver fix de negocio: las columnas antes
      // decían "... Organizador" y el valor se pisaba más abajo con el
      // organizador sacado de EVENT_DATOS_PERSONALES[0]; negocio pidió que
      // vuelvan a mostrar al comprador).
      // TAREA (pedida en un borrador anterior del Word, "¿Qué contiene? está
      // vacío") se confirmó con negocio que no va en el excel final — eliminada.
      defCols: [
        { value: "ORDERID", enabled: true, title: "Pedido", width: 150 },
        { value: "DATE_ADDED", enabled: true, title: "Fecha de Pedido", width: 150 },
        { value: "STORENAME", enabled: true, title: "Tienda", width: 150 },
        { value: "STORENAME2", enabled: true, title: "Tienda Registro", width: 150 },
        // -- Detalle de SKU (solo aplican a la pestaña Pedidos SKUs, ver SKU_TAB_ORDER) --
        { value: "SKU", enabled: true, title: "SKU", width: 130 },
        { value: "SKU_NAME", enabled: true, title: "Nombre Específico", width: 200 },
        { value: "SKU_CATEGORYNAME", enabled: true, title: "Categoría Madre", width: 200 },
        { value: "SKU_KEYVARIANT", enabled: true, title: "Key Variante", width: 150 },
        { value: "SKU_SIZE", enabled: true, title: "Talla", width: 100 },
        { value: "SKU_REGULAR_PRICE", enabled: true, title: "Precio Regular", width: 150 },
        { value: "SKU_PRICE", enabled: true, title: "Precio", width: 150 },
        { value: "SKU_QUANTITY", enabled: true, title: "Cantidad", width: 100 },
        { value: "SKU_TOTAL", enabled: true, title: "Total SKU", width: 150 },

        { value: "SUBTOTAL_ORDER", enabled: true, title: "Subtotal", width: 150 },
        { value: "SHIPPINGCOST", enabled: true, title: "Costo de Envío", width: 150 },
        { value: "DISCOUNT", enabled: true, title: "Descuento", width: 150 },
        { value: "TOTAL_ORDER", enabled: true, title: "Total", width: 150 },
        { value: "STATUSNAME", enabled: true, title: "Estado", width: 150 },
        { value: "DATE_MODIFIED", enabled: true, title: "Fecha de Actualización", width: 150 },
        { value: "HAVECOUPON", enabled: true, title: "Nombre Cupón", width: 150 },
        { value: "COUPONCODE", enabled: true, title: "Código Cupón", width: 150 },
        { value: "COUPONADMINCODE", enabled: true, title: "Código Interno", width: 150 },
        { value: "COUPONVALUE", enabled: true, title: "Valor Cupón", width: 150 },
        { value: "POSICION_RACK", enabled: true, title: "Posición Rack", width: 150 },
        { value: "OBSERVACION", enabled: true, title: "Observación", width: 200 },
        { value: "EVENTTYPE", enabled: true, title: "Tipo Evento", width: 150 },
        { value: "EVENTNAME", enabled: true, title: "Nombre Evento", width: 200 },
        { value: "FIRSTNAME", enabled: true, title: "Nombre", width: 150 },
        { value: "LASTNAME", enabled: true, title: "Apellido", width: 150 },
        { value: "EMAIL", enabled: true, title: "Email", width: 200 },
        { value: "PHONE", enabled: true, title: "Teléfono", width: 150 },
        { value: "SHIPPINGADDRESS", enabled: true, title: "Dirección de Envío Organizador", width: 200 },
        { value: "ADDITIONALSHIPPINGINSTRUCTIONS", enabled: true, title: "Instrucción de Envío (Evento)", width: 250 },
        { value: "ZONECODE", enabled: true, title: "Código de Zona", width: 150 },
        { value: "SHIPPING_CITY", enabled: true, title: "Ciudad de Envío", width: 150 },
        { value: "SHIPPINGMETHOD", enabled: true, title: "Método de Envío", width: 150 },
        { value: "SHIPPINGTYPE", enabled: true, title: "Tipo de Envío", width: 150 },
        { value: "NIT", enabled: true, title: "NIT", width: 130 },
        { value: "RAZON_SOCIAL", enabled: true, title: "Razón Social", width: 200 },
        { value: "NROFACTURA", enabled: true, title: "Número Factura", width: 150 },
        { value: "TRX", enabled: true, title: "TRX", width: 150 },
        { value: "OPCIONCLIENTE", enabled: true, title: "Opción Cliente", width: 200 },
        { value: "NOTA_SAP", enabled: true, title: "Nota sap", width: 150 },
        { value: "INVOICE_STATUS", enabled: true, title: "Estado Factura", width: 150 },
        { value: "INVOICE_DATE", enabled: true, title: "Fecha Factura", width: 150 },
      ],
    };
  }

  componentDidMount = async () => {
    require("antd/dist/antd.css");
    console.log("init 2.0.0 (single source / redesign)");
    applyExternalDarkMode(this.props.location.search);

    const api_urlV2 = API_CONFIG.casaideasInt;
    this.setState({ api_urlV2 });

    // Tipo Evento (regalables): mismo lambda de eventos que ya usa indexHistNew.js
    // (event/search por eventcode), cruzado con el domain "tipo_evento" ya
    // fetcheado más abajo. Si un pedido no matchea, EVENTTYPE queda en blanco.
    axios({
      url: `${process.env.REACT_APP_APIEVEN_CONFIG}/api/frontend/event/search?eventname=`,
      data: {},
      headers: { "Content-Type": "application/json" },
      method: "get",
    })
      .then((response) => response.data)
      .then((data) => this.setState({ events: data.rows || [] }))
      .catch((err) => console.log(">>>>>>>>>> events fetch", err));

    try {
      const [dashboardResp, resp1, resp2, resp3, resp4, resp5, resp6, resp0] = await Promise.all([
        axios({
          url: API_CONFIG.xflowurl + "/components/get-single-by-code",
          data: { component: "dashboards", code: "REP001" },
          headers: { "Content-Type": "application/json" },
          method: "post",
        }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", { domainName: "metodos_pago" }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", { domainName: "metodos_envio" }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", { domainName: "tiendas" }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", { domainName: "estados_orden" }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", { domainName: "POLYGONS" }),
        callexternalApi(api_urlV2, "/api/getCoupons", "post", { apikey: API_CONFIG.casaideasIntToken }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", {
          domainName: "dominios",
          custom: { name: "dominio", value: "tipo_evento" },
        }),
      ]);

      const compinfo = dashboardResp.data.data.DATA;
      const filterConfig = { ...this.state.filterConfig };

      filterConfig.EVENTTYPEID.values = [{ text: "TODOS", value: "" }].concat(
        resp0.rows.map((item) => ({ text: item.nombre, value: item.value }))
      );
      filterConfig.PAYMENTTYPEID.values.push(...resp1.rows.map((item) => ({ text: item.metodo_pago, value: item.value })));
      filterConfig.SHIPPINGTYPEID.values.push(...resp2.rows.map((item) => ({ text: item.metodo_envio, value: item.value })));
      filterConfig.STOREID.values.push(...resp3.rows.map((item) => ({ text: item.tienda, value: item.value })));
      filterConfig.STATUSID.values.push(...resp4.rows.map((item) => ({ text: item.estado, value: item.value })));

      const cities = [...new Set(resp5.rows.map((item) => item.region))];
      filterConfig.CITY.values.push(...cities.map((city) => ({ text: city, value: city })));

      filterConfig.COUPONNAME.values.push(...resp6.rows.map((item) => ({ text: item.couponname, value: item.id })));

      this.setState({ compinfo, filterConfig, tipos_evento: resp0.response || [] });
    } catch (err) {
      console.log(">>>>>>>>>>", err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  setFilterValue = (name, value) => {
    this.searchHandler({ target: { name, value } });
  };

  ///Search Manager
  searchHandler = async (event) => {
    this.setState({ isLoading: true });

    const searchStartTime = performance.now();

    let searchConfig = this.state.filterConfig;
    // findObjName sube por el DOM: el click puede caer en el icono/texto interno del boton.
    if (findObjName(event) === "search") {
      // Copia para no alterar lo que muestra el selector de fecha.
      searchConfig = {
        ...searchConfig,
        FROMDATE: { ...searchConfig.FROMDATE, value: boliviaDayStart(searchConfig.FROMDATE.value) },
        TODATE: { ...searchConfig.TODATE, value: boliviaDayEnd(searchConfig.TODATE.value) },
      };
    }

    let resp = await searchHandler(
      event,
      searchConfig,
      this.state.showMore,
      this.state.api_urlV2 + "/api/orders/repOrderEvent",
      null
    );

    if (resp.filterConfig) {
      this.setState({ filterConfig: resp.filterConfig });
    }

    var summary = this.state.summary;
    var exportOrderCols = this.state.exportOrderCols;
    var exportSkuCols = this.state.exportSkuCols;
    var exportOrders = this.state.exportOrders;
    var exportSkus = this.state.exportSkus;
    var newExportOrderCols, newExportSkuCols;

    if (resp.tableData) {
      let rows = [];
      const orders = [];

      for (const r in resp.tableData.orders || []) {
        const field = resp.tableData.orders[r];
        const pos = orders.indexOf(field.ORDERID);

        let tipo_pedido_v = "PEDIDO ONLINE";
        try {
          if (field.PAYMENTMETHOD && field.PAYMENTMETHOD.includes("EVENTO")) {
            if (field.PAYMENTMETHOD === "EVENT-NO") tipo_pedido_v = "TIENDA COMPRA Y ENTREGA";
            else if (field.PAYMENTMETHOD === "EVENTO-SI") tipo_pedido_v = "TIENDA SOLO COMPRA";
            else if (field.PAYMENTMETHOD === "EVENTO-CLIENTE") tipo_pedido_v = "Cliente llevará el regalo (No xFlow)";
          }
        } catch (e) {
          tipo_pedido_v = "NO DEF";
        }
        field["EXTORDERTYPE"] = tipo_pedido_v;

        if (pos < 0) {
          orders.push(field.ORDERID);
          // Tienda Registro: ahora viene directo del backend (o.tienda_pickup si
          // hay sub-tienda, si no o.tienda_code de la tienda de compra) - siempre
          // el codigo de tiendas (ej. "LP01"), sin importar el metodo de pago.
          field["STORENAME2"] = field["STORENAME2"] || field.STOREPICKUP || field.STORENAME;
          if (field["STATUSID"] === 19) field["STATUSNAME"] = "Cancelado";

          // Tipo Evento: ahora viene directo del backend (o.tipo_evento, calculado
          // al crear el pedido). El cruce por EVENTID contra el lambda de eventos +
          // domain tipo_evento queda solo de fallback para pedidos viejos sin el
          // campo poblado en BD.
          field["EVENTTYPE"] = field["EVENTTYPE"] || "";
          if (!field["EVENTTYPE"]) {
            const posE = find(this.state.events, field.EVENTID, "eventcode");
            if (posE >= 0) {
              const posTE = find(this.state.tipos_evento, this.state.events[posE].eventtypeid, "SK");
              if (posTE >= 0) field["EVENTTYPE"] = this.state.tipos_evento[posTE].text;
            }
          }

          // Direccion de envio del evento: no viene de la orden, se guarda
          // aparte en el formulario de evento (EVENT_DIRECTIONS; puede venir
          // "" si el evento no tiene direccion cargada, en ese caso se deja
          // todo vacio). FIRSTNAME/LASTNAME/EMAIL/PHONE en cambio SÍ vienen
          // poblados directo en `field` desde el backend (o.nombre/o.email/
          // etc. de la orden, quien compró) — no se tocan acá; antes se
          // pisaban con el organizador del evento (EVENT_DATOS_PERSONALES[0]),
          // lo que negocio pidió sacar (el reporte debe mostrar al comprador).
          const eventDirections = field.EVENT_DIRECTIONS && typeof field.EVENT_DIRECTIONS === "object"
            ? field.EVENT_DIRECTIONS
            : null;
          field["SHIPPINGADDRESS"] = (eventDirections && eventDirections.address) || "";
          field["ADDITIONALSHIPPINGINSTRUCTIONS"] = (eventDirections && eventDirections.reference) || "";
          field["ZONECODE"] = (eventDirections && eventDirections.zonecode) || "";
          field["SHIPPING_CITY"] = (eventDirections && eventDirections.city) || "";

          rows.push(field);
        }
      }

      this.state.defCols.forEach((item) => {
        if (!item.enabled) rows.forEach((row) => delete row[item.value]);
      });

      const tableData = this.state.tableData;
      tableData.rows = rows;

      let rowsO = resp.tableData.ordersskus || [];
      rowsO.forEach((row) => {
        const matchingItem = rows.find((item) => item.ORDERID === row.ORDERID);
        if (matchingItem) {
          row["COUPONCODE"] = matchingItem.COUPONCODE || "";
          row["COUPONADMINCODE"] = matchingItem.COUPONADMINCODE || "";
          row["COUPONVALUE"] = matchingItem.COUPONVALUE || "";
          row["HAVECOUPON"] = matchingItem.HAVECOUPON || "";
          row["STATUSNAME"] = matchingItem.STATUSNAME;
          row["STORENAME2"] = matchingItem.STORENAME2 || "";
          row["EVENTNAME"] = matchingItem.EVENTNAME;
          row["EVENTTYPE"] = matchingItem.EVENTTYPE || "";
          row["NOTA_SAP"] = matchingItem.NOTA_SAP;
          row["TRX"] = matchingItem.TRX;
          row["NROFACTURA"] = matchingItem.NROFACTURA;
          row["INVOICE_STATUS"] = matchingItem.INVOICE_STATUS;
          row["INVOICE_DATE"] = matchingItem.INVOICE_DATE;
          row["POSICION_RACK"] = matchingItem.POSICION_RACK;
          row["NIT"] = matchingItem.NIT || "";
          row["RAZON_SOCIAL"] = matchingItem.RAZON_SOCIAL || "";
          row["OBSERVACION"] = matchingItem.OBSERVACION || "";
          row["OPCIONCLIENTE"] = matchingItem.OPCIONCLIENTE || "";
          row["SHIPPING_CITY"] = matchingItem.SHIPPING_CITY || "";
        }
      });

      this.state.defCols.forEach((item) => {
        if (!item.enabled) rowsO.forEach((row) => delete row[item.value]);
      });

      rowsO = rowsO.reduce((acc, row) => acc.concat(expandComboSkuRows(row)), []);

      const tableData2 = this.state.tableData2;
      tableData2.rows = rowsO;

      const defColsByValue = new Map(
        this.state.defCols.map((item) => [item.value, item])
      );

      var _columns = [];
      var _defCols = [];
      ORDER_TAB_ORDER.forEach((value) => {
        const item = defColsByValue.get(value);
        if (item && item.enabled) {
          _columns.push({ dataIndex: item.value, title: item.title, width: item.width });
          _defCols.push(item);
        }
      });
      tableData.columns = _columns;
      newExportOrderCols = _defCols;

      _defCols = [];
      _columns = [];
      // En la pestaña SKUs, Tienda Registro (STORENAME2) / Tienda (STORENAME)
      // se renombran a "Tienda Pick Up" / "Tienda Stock" por pedido de negocio.
      const SKU_TAB_TITLES = { STORENAME2: "Tienda Pick Up", STORENAME: "Tienda Stock" };
      SKU_TAB_ORDER.forEach((value) => {
        const item = defColsByValue.get(value);
        if (item && item.enabled) {
          const title = SKU_TAB_TITLES[value] || item.title;
          _columns.push({ dataIndex: item.value, title, width: item.width });
          _defCols.push({ ...item, title });
        }
      });
      tableData2.columns = _columns;
      newExportSkuCols = _defCols;

      const totalUnits = rowsO.reduce((acc, item) => acc + Number(item.SKU_QUANTITY || 0), 0);
      const totalAmount = rows.reduce((acc, item) => acc + Number(item.TOTAL_ORDER || 0), 0);
      summary = {
        orders: rows.length,
        units: totalUnits,
        total: totalAmount,
        avgTicket: rows.length ? totalAmount / rows.length : 0,
        withCoupon: rows.filter((item) => item.HAVECOUPON && item.HAVECOUPON !== "NO").length,
        elapsed: ((performance.now() - searchStartTime) / 1000).toFixed(1),
        fromDate: this.state.filterConfig.FROMDATE.value,
        toDate: this.state.filterConfig.TODATE.value,
      };

      exportOrders = rows;
      exportSkus = rowsO;
      exportOrderCols = newExportOrderCols;
      exportSkuCols = newExportSkuCols;

      window.location.hash = "#results";
    }

    this.setState({
      isLoading: false,
      exportOrders,
      exportSkus,
      exportOrderCols,
      exportSkuCols,
      summary,
    });
  };

  selectItem = (item) => {
    if (item !== "ORDERID" && item !== "SKU") {
      var defCols = this.state.defCols;
      defCols.forEach((row) => { if (row.value === item) row["enabled"] = !row["enabled"]; });
      this.setState({ defCols });
    }
  };

  selectAllItems = () => {
    var defCols = this.state.defCols;
    defCols.forEach((row) => { if (row.value !== "ORDERID" && row.value !== "SKU") row["enabled"] = true; });
    this.setState({ defCols, isChecked: true });
  };

  removeAllItem = () => {
    var defCols = this.state.defCols;
    defCols.forEach((row) => { if (row.value !== "ORDERID" && row.value !== "SKU") row["enabled"] = false; });
    this.setState({ defCols, isChecked: false });
  };

  /* ============ export a excel (exceljs, con formato real) ============ */

  exportToExcel = async () => {
    const { exportOrders, exportSkus, exportOrderCols, exportSkuCols, summary } = this.state;
    if (!exportOrders || !exportOrders.length) return;

    const fmtDate = (d) => (d ? moment(d).format("DD/MM/YYYY") : "-");
    const wb = new ExcelJS.Workbook();
    wb.creator = "Reporte de Regalables";
    wb.created = new Date();

    addSummarySheet(wb, {
      title: "Reporte de Pedidos — Regalables",
      generatedAt: moment().format("DD/MM/YYYY HH:mm"),
      period: `${fmtDate(summary?.fromDate)}  -  ${fmtDate(summary?.toDate)}`,
      kpis: [
        ["Pedidos", summary?.orders || 0],
        ["Productos procesados", summary?.units || 0],
        ["Ventas (Bs.)", Number((summary?.total || 0).toFixed(2))],
        ["Ticket Promedio (Bs.)", Number((summary?.avgTicket || 0).toFixed(2))],
        ["Pedidos con Cupón", summary?.withCoupon || 0],
      ],
    });

    addDataSheet(wb, { name: "Pedidos", rows: exportOrders, cols: exportOrderCols, moneyCols: MONEY_COLS, statusKey: "STATUSNAME" });
    addDataSheet(wb, { name: "Pedidos SKUs", rows: exportSkus, cols: exportSkuCols, moneyCols: MONEY_COLS, statusKey: "STATUSNAME" });

    await downloadWorkbook(wb, "export-regalables." + this.state.date_label + ".xlsx");
  };

  /* ============ render helpers ============ */

  renderCellByColumn = (col) => {
    if (col === "ORDERID") {
      return (text) => <span className="xrep2-orderid">{text}</span>;
    }
    if (col === "STATUSNAME" || col === "INVOICE_STATUS") {
      return (text) => (text ? <Tag color={statusColor(text)}>{text}</Tag> : "");
    }
    if (MONEY_COLS.indexOf(col) >= 0) {
      return (text) => (
        <span className="xrep2-money" style={col === "TOTAL_ORDER" || col === "SKU_TOTAL" ? { fontWeight: 700 } : {}}>
          {formatMoney(text)}
        </span>
      );
    }
    if (col === "SKU" || col === "TRX" || col === "NROFACTURA" || col === "POSICION_RACK") {
      return (text) => <span className="xrep2-mono">{text}</span>;
    }
    if (col === "EMAIL") {
      return (text) => <span style={{ color: "#1890ff" }}>{text}</span>;
    }
    return undefined;
  };

  tableScrollWidth = (columns) => (columns || []).reduce((acc, c) => acc + (c.width || 140), 0);

  buildAntColumns = (columns) =>
    (columns || []).map((c) => {
      const column = {
        key: c.dataIndex,
        dataIndex: c.dataIndex,
        title: c.title,
        width: c.width || 140,
        ellipsis: true,
        render: this.renderCellByColumn(c.dataIndex),
      };
      if (MONEY_COLS.indexOf(c.dataIndex) >= 0 || c.dataIndex === "ORDERID") {
        column.sorter = (a, b) =>
          Number(String(a[c.dataIndex]).replace(/[^0-9.-]/g, "") || 0) -
          Number(String(b[c.dataIndex]).replace(/[^0-9.-]/g, "") || 0);
      }
      if (c.dataIndex === "STATUSNAME") {
        column.sorter = (a, b) => String(a.STATUSNAME || "").localeCompare(String(b.STATUSNAME || ""));
      }
      return column;
    });

  renderFilterField = (field) => {
    const cfg = this.state.filterConfig[field];
    if (!cfg) return null;

    let control = null;

    if (cfg.type === "DATE") {
      control = (
        <DatePicker
          style={{ width: "100%" }}
          allowClear={false}
          value={cfg.value ? moment(cfg.value) : moment()}
          format="DD/MM/YYYY"
          dropdownClassName="xrep2-popup"
          onChange={(m) => this.setFilterValue(field, m ? m.toDate() : new Date())}
        />
      );
    } else if (cfg.type === "SELECT") {
      control = (
        <Select
          style={{ width: "100%" }}
          value={cfg.value}
          onChange={(v) => this.setFilterValue(field, v)}
          showSearch
          optionFilterProp="children"
          dropdownClassName="xrep2-popup"
        >
          {cfg.values.map((item) => (
            <Option key={"opt_" + field + "_" + item.value} value={item.value}>
              {item.text}
            </Option>
          ))}
        </Select>
      );
    } else if (cfg.type === "MULTIPLE") {
      const currentValue = Array.isArray(cfg.value) ? cfg.value : cfg.value === "" || cfg.value === undefined ? [] : [cfg.value];
      control = (
        <Select
          mode="multiple"
          allowClear
          maxTagCount={2}
          placeholder="Todos"
          style={{ width: "100%" }}
          value={currentValue}
          onChange={(vals) => {
            let value = (vals || []).map((v) => (isNaN(parseInt(v)) ? v : parseInt(v)));
            if (value.length === 0) value = "";
            else if (value.length === 1) value = value[0] + "";
            this.setFilterValue(field, value);
          }}
          optionFilterProp="children"
          dropdownClassName="xrep2-popup"
        >
          {cfg.values.filter((item) => item.value !== "").map((item) => (
            <Option key={"opt_" + field + "_" + item.value} value={item.value}>
              {item.text}
            </Option>
          ))}
        </Select>
      );
    } else {
      control = <Input value={cfg.value} onChange={(e) => this.setFilterValue(field, e.target.value)} allowClear />;
    }

    return (
      <div className="xrep2-field" key={"f_" + field}>
        <label>{cfg.label}</label>
        {control}
      </div>
    );
  };

  render() {
    const { summary, tableData, tableData2, activeTab, showAllFilters } = this.state;

    const primaryFilters = ["FROMDATE", "TODATE", "ORDERID", "ORDERID_TO", "CUSTOMER_NAME", "EVENTTYPEID"];
    const extraFilters = ["CITY", "STOREID", "STATUSID", "PAYMENTTYPEID", "SHIPPINGTYPEID", "MIN_PRICE", "MAX_PRICE", "HAVE_COUPON", "COUPONNAME"];

    const kpis = summary
      ? [
        { label: "Pedidos", value: summary.orders, icon: "fas fa-gift", color: "#1890ff" },
        { label: "SKUs", value: summary.units, icon: "fas fa-boxes", color: "#722ed1" },
        { label: "Ventas (Bs.)", value: formatMoney(summary.total), icon: "fas fa-coins", color: "#52c41a" },
        { label: "Ticket Promedio", value: formatMoney(summary.avgTicket), icon: "fas fa-receipt", color: "#fa8c16" },
        { label: "Con Cupón", value: summary.withCoupon, icon: "fas fa-ticket-alt", color: "#13c2c2" },
      ]
      : [];

    const pagination = {
      pageSize: this.state.pageSize,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
      showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`,
      onShowSizeChange: (current, size) => this.setState({ pageSize: size }),
      onChange: (page, size) => this.setState({ pageSize: size }),
    };

    return (
      <>
        <style>{PAGE_CSS}</style>
        <PageLoading isLoading={this.state.isLoading} />

        <Drawer
          title="Campos a exportar"
          placement="right"
          width={420}
          className="xrep2-drawer"
          visible={this.state.drawerFields}
          onClose={() => this.setState({ drawerFields: false })}
        >
          <div style={{ marginBottom: 12, display: "flex", gap: 8 }}>
            {this.state.isChecked ? (
              <Button size="small" onClick={this.removeAllItem}>Desmarcar todos</Button>
            ) : (
              <Button size="small" type="primary" onClick={this.selectAllItems}>Marcar todos</Button>
            )}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px 10px" }}>
            {this.state.defCols.map((row) => (
              <Checkbox
                key={"chk_" + row.value}
                checked={row.enabled}
                disabled={row.value === "ORDERID" || row.value === "SKU"}
                onChange={() => this.selectItem(row.value)}
              >
                {row.title}
              </Checkbox>
            ))}
          </div>
        </Drawer>

        <div className="page-wrapper xext-page xext-exportorders-event">
          <div className="content container-fluid xrep2">
            <div className="xrep2-header">
              <div className="xrep2-title">
                <h2>
                  <i className="fas fa-gifts" style={{ color: "#1890ff", marginRight: 10 }} />
                  Reporte de Pedidos — Regalables
                </h2>
                <small>Pedidos y SKUs de eventos / regalos</small>
              </div>
              <div className="xrep2-actions">
                {summary && <span className="xrep2-elapsed"><i className="far fa-clock" /> {summary.elapsed}s</span>}
                <Button icon={<i className="fas fa-columns" style={{ marginRight: 6 }} />} onClick={() => this.setState({ drawerFields: true })}>
                  Columnas
                </Button>
                <Button
                  type="primary"
                  disabled={tableData.rows.length === 0}
                  onClick={this.exportToExcel}
                  style={tableData.rows.length ? { background: "#52c41a", borderColor: "#52c41a" } : {}}
                  icon={<i className="fas fa-file-excel" style={{ marginRight: 6 }} />}
                >
                  Exportar Excel
                </Button>
              </div>
            </div>

            <div className="xrep2-panel">
              <div className="xrep2-filters-grid">
                {primaryFilters.map((field) => this.renderFilterField(field))}
                {showAllFilters && extraFilters.map((field) => this.renderFilterField(field))}
              </div>
              <div className="xrep2-filters-footer">
                <Button type="link" size="small" onClick={() => this.setState({ showAllFilters: !showAllFilters })}>
                  <i className={"fas fa-angle-" + (showAllFilters ? "up" : "down")} style={{ marginRight: 5 }} />
                  {showAllFilters ? "Menos filtros" : "Más filtros"}
                </Button>
                <Button
                  type="primary"
                  size="large"
                  name="search"
                  onClick={this.searchHandler}
                  icon={<i className="fas fa-search" style={{ marginRight: 8 }} />}
                >
                  Generar Reporte
                </Button>
              </div>
            </div>

            {summary && (
              <div className="xrep2-kpis" id="results">
                {kpis.map((kpi) => (
                  <div className="xrep2-kpi" key={kpi.label}>
                    <div className="xrep2-kpi-icon" style={{ background: kpi.color }}>
                      <i className={kpi.icon} />
                    </div>
                    <div>
                      <p className="xrep2-kpi-label">{kpi.label}</p>
                      <p className="xrep2-kpi-value">{kpi.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="xrep2-tables">
              {tableData.rows.length === 0 ? (
                <Empty style={{ padding: "40px 0" }} description="Configura los filtros y presiona Generar Reporte" />
              ) : (
                <Tabs activeKey={activeTab} onChange={(key) => this.setState({ activeTab: key })}>
                  <TabPane
                    tab={<span><i className="fas fa-gift" style={{ marginRight: 6 }} />Pedidos ({tableData.rows.length})</span>}
                    key="orders"
                  >
                    <AntTable
                      size="small"
                      tableLayout="fixed"
                      columns={this.buildAntColumns(tableData.columns)}
                      dataSource={tableData.rows}
                      rowKey={(record, index) => "o" + index}
                      pagination={pagination}
                      scroll={{ x: this.tableScrollWidth(tableData.columns) }}
                    />
                  </TabPane>
                  <TabPane
                    tab={<span><i className="fas fa-barcode" style={{ marginRight: 6 }} />Detalle SKUs ({tableData2.rows.length})</span>}
                    key="skus"
                  >
                    <AntTable
                      size="small"
                      tableLayout="fixed"
                      columns={this.buildAntColumns(tableData2.columns)}
                      dataSource={tableData2.rows}
                      rowKey={(record, index) => "s" + index}
                      pagination={pagination}
                      scroll={{ x: this.tableScrollWidth(tableData2.columns) }}
                    />
                  </TabPane>
                </Tabs>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default page;
